import { Component, OnInit } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataService, HelperService, HTTPService } from '../../../../services';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-swipe-card-confirmation',
  templateUrl: './swipe-card-confirmation.component.html',
  styleUrls: ['./swipe-card-confirmation.component.scss'],
})
export class SwipeCardConfirmationComponent implements OnInit {
  data: any = {};
  defaultStatus: string = 'In Progress';
  title: string = 'Payment';
  status: string = this.defaultStatus;
  unsubscribe: Subject<boolean> = new Subject<boolean>();
  usd: string = currency.USD;
  isGlobalPayment: boolean = false;
  type = 'payment'
  isRefund: boolean = false;
  isCanada : boolean = false;
  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private httpService: HTTPService,
    public helperService: HelperService
  ) {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
    this.isCanada = this.dataService.isCountryCanada;
    if (this.data.isGlobalPayment) {
      this.isGlobalPayment = true;
    }
    if(this.data.isRefund) {
      this.type = 'refund'
    }
    if (this.data.title) {
      this.title = this.data.title;
    }
    this.setListeners();
  }

  closeDialog(isSuccess: boolean, btn = '') {
    this.data.btn = btn;
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    if (btn !== 'close') {
      this.dynamicDialogRef.close({ isSuccess, data: this.data });
    } else {
      this.dynamicDialogRef.close();
    }
  }

  cancelPayment(): void {
    const type = this.isGlobalPayment ? 'globalPay' : 'payrix';
    this.httpService.cancelPayment(this.dialogConfig.data.id, type).then(
      (res) => {
        // 1 = Approved  || 3 = Captured  || 4 = Settled
        if(res.isGlobalPay){
          this.helperService.showToaster('success', res.msg);
        }
        if ([1, 3, 4].includes(res.status)) {
          this.helperService.showToaster('error', 'The transaction has been approved already and cannot be canceled now');
          this.dynamicDialogRef.close(false);
          // window.location.reload();
        }
        
        this.dynamicDialogRef.close(false);
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.dynamicDialogRef.close(false);
      }
    );
  }

  setListeners() {
    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ data }) => {
        if (!data) {
          return;
        }
        if (data.key === 'payment-inprogress-model-close') {
          this.helperService.showToaster('success', 'payment recorded');
          this.dynamicDialogRef.close();
          this.dataService.sendData(this.dataService.typePassData('partial-order-reload', {}));
        }
      });
  }
  checkStatus() {
    this.status = 'Checking';
    const type = this.isGlobalPayment ? 'globalPay' : 'payrix';
    this.httpService.checkPaymentStatus(this.dialogConfig.data.id, type).then(
      (res) => {
        this.status = this.helperService.getPayrixPaymentStatus(res.status);
        // 1 = Approved  || 3 = Captured  || 4 = Settled
        if ([1, 3, 4].includes(res.status)) {
          if(res.isGlobalPayResponse){
            this.helperService.showToaster('success', 'payment recorded');
            window.location.reload();
          }
          this.dynamicDialogRef.close(false);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.dynamicDialogRef.close(false);
      }
    );
  }
}
